import { Phone, MessageCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/918940988776?text=Hi%2C%20I%20need%20consultation%20for%20tax%20services%20in%20Coimbatore.%20Please%20assist%20me";
const PHONE_URL = "tel:+918940988776";

const MobileStickyBar = () => (
  <div className="mobile-sticky-bar" data-testid="mobile-sticky-bar">
    <a
      href={PHONE_URL}
      className="flex-1 btn-primary text-center flex items-center justify-center gap-2"
      data-testid="mobile-call-btn"
    >
      <Phone size={18} />
      Call
    </a>
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="flex-1 btn-whatsapp justify-center"
      data-testid="mobile-whatsapp-btn"
    >
      <MessageCircle size={18} />
      WhatsApp
    </a>
  </div>
);

export default MobileStickyBar;
